import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import alertTriangle from "../../assets/images/alert.svg";
import "./alert.css";

const AlertCancel = ({ title, desc, setShowWarn }) => {
    return (
        <Box className="successAlert warnAlert" p={{ sm: 2, xs: 1 }} display={"flex"} alignItems={"flex-start"} justifyContent={"space-between"}>
            <Box className="successDesc" display={"flex"} alignItems={"flex-start"}>
                <img src={alertTriangle} alt="alert" />
                <Box mx={{ sm: 2, xs: 1 }}>
                    <Typography variant="h3">{title}</Typography>
                    <Typography>{desc}</Typography>
                    <Link to="">Learn how you can get a free membership <span>Undo cancellation <ArrowForwardIcon /></span></Link>
                </Box>
            </Box>
            <Box className="closeModal" onClick={() => setShowWarn(false)}><CloseIcon /></Box>
        </Box>
    )
}

export default AlertCancel;
